import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {TableFilterDirective} from "../../../directives/table-filter/table-filter.directive";


@Component({
  selector: 'app-table-filter-header',
  standalone: true,
  imports: [
    FormsModule
],
  templateUrl: './table-filter-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './table-filter-header.component.scss'
})
export class TableFilterHeaderComponent {
  @Input() tableFilterName: string | null = null;
  @Input() choices: { label: string, value: string }[] | null = null;

  private tableFilter: TableFilterDirective | null = null;
  searchText: string = '';

  setTableFilter(tableFilter: TableFilterDirective): void {
    this.tableFilter = tableFilter;
  }

  reset(): void {
    this.searchText = '';
  }

  onChanged(): void {
    if (this.tableFilterName) {
      this.tableFilter?.setFilter(this.tableFilterName, this.searchText);
    }
  }

  onModelChanged(e: any): void {
    this.searchText = e;
    if (this.tableFilter?.isRealtime()) {
      this.onChanged();
    }
  }

  hasChoices(): boolean {
    return this.choices !== null;
  }
}
